<template>
  <div class="rounded comp-qtd text-primary mt-0" :class="{'border': borda, 'box-sm': small}">
    <div class="comp-item" @click="change(false)" :class="{'text-black-50' : qtd === 1}">
      <i class="fa fa-minus"></i>
    </div>
    <div class="comp-item comp-output"><b>{{qtd}}</b></div>
    <div class="comp-item" @click="change(true)" :class="{'text-black-50' : qtd == max}">
      <i class="fa fa-plus"></i>
    </div>
  </div>
</template>

<script>
  export default {
    name: "quantidade",
    props: ["qtdInicial","borda","max", "small"],
    data () {
      return {
        qtd: 1,
      }
    },

    methods: {
      change(tipo) {
        if (!tipo) {
          this.qtd = this.qtd > 1 ? --this.qtd : 1;

        } else if (this.qtd < this.max) {
          this.qtd++;
        }

        this.$emit('change', this.qtd);
      }
    },

    mounted() {
      this.qtd = this.qtdInicial > 0 ? parseInt(this.qtdInicial) : 1;
    }
  }
</script>

<style scoped>
  .comp-qtd {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }
  .comp-item {
    width: 33.333333%;
    text-align: center;
    padding: 8px 0;
    cursor: pointer;
  }

  .box-sm .comp-item {
    padding: 6px 0;
  }

  .comp-output {
    color: #6c757d;
  }

  .box-sm .comp-output {
    font-size: 0.9rem;
  }
</style>
